var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-dots"},_vm._l((_vm.total),function(dot,index){return _c('button',{key:index,staticClass:"scroll-dots__dot",class:{ active: _vm.currentSection === index },attrs:{"aria-label":`섹션 ${index + 1}로 이동`},on:{"click":function($event){return _vm.$emit('navigate', index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }